<template>
  <div>
    <transition name="fade" mode="out-in">
      <div id="frame" class="fpds-Stack u-minHeightScreen">
        <div
          id="header"
          class="u-paddingMedium u-backgroundWhite u-flex u-alignItemsCenter u-borderBottomMedium"
          style="border-color: #336187"
        >
          <div id="header-brand" class="u-flexInitial header-buttons">
            <img
              src="https://resources.fphcare.com/resources/corporate/media/system/logo.png"
              alt="Fisher & Paykel Healthcare"
              class="u-marginRightXLarge"
              style="height: 26px"
            />
            <div> 
              <ActionButton :on-click="backToCMS" class="mr-2">
                     {{ $t("profile-header.buttons.back") }}
              </ActionButton>
            </div>
           
          </div>
          <div class="u-flexFill">
            <UserMenu v-if="$store.state.currentProfile" />
          </div>
        </div>
        <div class="u-flex u-flexGrow">
          <div class="u-flex u-widthFull">
            <div id="app" class="u-widthFull">
              <div
                v-if="$store.state.currentProfile"
                key="authenticated"
                class="fpds-Stack u-widthFull u-minHeightFull"
              >
                <Notifications />
                <div class="u-flex u-flexGrow">
                  <!-- <TheSidebar /> -->
                  <TheContainer>
                    <router-view />
                  </TheContainer>
                </div>
              </div>

              <div
                v-else
                id="app"
                key="unauthenticated"
                class="
                  fpds-Stack fpds-Stack--alignCenter fpds-Stack--alignVerticalCenter
                  u-widthFull u-minHeightFull
                "
              >
                <div class="fpds-Stack fpds-Stack--alignCenter u-marginBottomXXXLarge">
                  <div class="fpds-ProgressSpinner u-marginBottomMedium"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import TheContainer from "./components/TheContainer";
import Notifications from "./notifications/Notifications";
import ProfileService from "./services/ProfileService";
import UserMenu from "./components/UserMenu";
import ActionButton from "./components/ActionButton";

export default {
  name: "App",
  components: { TheContainer, Notifications, UserMenu,ActionButton },
  async mounted() {},
  methods: {
    logOut() {
      ProfileService.logOut();
    },
    backToCMS() {
       window.history.back()
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.header-buttons
{
  display: flex;
  flex-direction:row;
  align-items: center;

  .mr-2
  {
    margin-left:24px;
  }
}
</style>
